/**
 * PUT /registration_tracker/{id} expects the tracker PK. Registrations rows are
 * tracker records themselves, so `row.id` is that PK; dedicated fields are
 * still preferred in case the payload starts wrapping them in notifications.
 */

function firstNonEmpty(candidates) {
  const found = candidates.find(
    (candidate) => candidate != null && String(candidate).trim() !== ""
  );
  return found != null ? String(found).trim() : null;
}

function getTrackerIdFromNavigation(row) {
  const navigation = row?.action?.target?.navigation;
  const query = navigation?.query;

  const fromQuery =
    query != null && typeof query === "object" && !Array.isArray(query)
      ? firstNonEmpty([
          query.registration_tracker_id,
          query.tracker_id,
          query.registration_id,
          query.id,
        ])
      : null;

  if (fromQuery) {
    return fromQuery;
  }

  const path = String(navigation?.path ?? "");
  return path.match(/registration_tracker\/(\d+)/)?.[1] ?? null;
}

export function getNotificationCenterRegistrationTrackerId(row) {
  return (
    firstNonEmpty([
      row?.registration_tracker_id,
      row?.registrationTrackerId,
      row?.tracker_id,
      row?.trackerId,
      row?.object_id,
      row?.objectId,
      row?.id,
    ]) ?? getTrackerIdFromNavigation(row)
  );
}

export function isNotificationCenterRowHighlighted(row) {
  return row?.highlighted === true;
}
